﻿require('jquery');
require('popper.js');
require('bootstrap');

// ensure jQuery is registered globally..
window.jQuery = window.$ = $;

$(function () {
    $('[data-toggle="tooltip"]').tooltip();
});

